import { LocalizedContentItem } from '../../store/interfaces';

/**
 * @param obj - Any json object
 * @param localizedContentMap - Corresponding localized data in the form of key value pair
 */
const localizeContentMapper = <T>(obj: T, localizedContentArray: LocalizedContentItem[] | undefined): T => {
  let localizedContentMap: Record<string, string> = {};
  if (localizedContentArray && localizedContentArray.length) {
    localizedContentMap = localizedContentArray.reduce((acc: Record<string, string>, cur: LocalizedContentItem) => {
      acc[cur.key] = cur.value;
      return acc;
    }, {});
  }

  const getLocalizedValue = (key: string): string =>
    localizedContentMap[key] || localizedContentMap[key] === '' || localizedContentMap[key] === null
      ? localizedContentMap[key]
      : key;

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const deepIterator = (target: any): void => {
    if (typeof target === 'object') {
      for (const key in target) {
        // TO BE REMOVED LATER: Converting all stringified booleans to booleans
        if (target[key] === 'true' || target[key] === 'false') {
          target[key] = target[key] === 'true';
          continue;
        }
        if (typeof target[key] === 'string') {
          target[key] = getLocalizedValue(target[key]);
          continue;
        }
        deepIterator(target[key]);
      }
    }
  };

  deepIterator(obj);
  return obj;
};

export default localizeContentMapper;
